import { type SearchableDropdownOption } from '@/components/SearchableDropdown';
import {
  DecoratedCompany,
  DecoratedInvestor,
} from '@flemingmetrics/api-client';
import { renderProfileName } from '@/utils/strings';

export type SelectOption = SearchableDropdownOption<number>;

export const classes = {
  dialogTitle: 'pb-2 items-center',
  dialog:
    'w-[98vw] min-w-[450px] max-w-[1250px] min-h-[300px] max-h-[650px] h-[80vh] flex flex-col',
  body: 'flex w-full grow pt-8',
  title: 'mb-6',
  divider: 'mx-8 py-0 my-0',
  leftCol: 'w-2/5 flex flex-col max-w-[350px]',
  rightCol: 'w-3/5 flex flex-col',
  dropdown: 'w-full mb-8',
  input: 'w-full mb-8',
};

export function buildCompanyOption(company: DecoratedCompany): SelectOption {
  return {
    label: company.name,
    value: company.id,
  };
}

export function buildInvestorOption(investor: DecoratedInvestor): SelectOption {
  return {
    label: renderProfileName(investor.profile),
    value: investor.id,
  };
}
